module.exports = __webpack_public_path__ + "static/media/almalinux-icon-white.b69ec33b.svg";